import { useEffect, useState } from "react";
import AppShell from "./components/layout/AppShell";
import AdminPage from "./pages/AdminPage";
import ContactPage from "./pages/ContactPage";
import HomePage from "./pages/HomePage";
import PricingPage from "./pages/PricingPage";
import RealizationsPage from "./pages/RealizationsPage";
import ServicesPage from "./pages/ServicesPage";

const pages = {
  home: HomePage,
  services: ServicesPage,
  pricing: PricingPage,
  realizations: RealizationsPage,
  contact: ContactPage,
  admin: AdminPage,
};

function getInitialPage() {
  const hash = window.location.hash.replace("#", "");
  return pages[hash] ? hash : "home";
}

function App() {
  const [page, setPage] = useState(getInitialPage);
  const Page = pages[page] || HomePage;

  useEffect(() => {
    const syncFromHash = () => setPage(getInitialPage());
    window.addEventListener("hashchange", syncFromHash);
    return () => window.removeEventListener("hashchange", syncFromHash);
  }, []);

  const handleNavigate = (nextPage) => {
    window.location.hash = nextPage;
    setPage(nextPage);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <AppShell page={page} onNavigate={handleNavigate}>
      <Page onNavigate={handleNavigate} />
    </AppShell>
  );
}

export default App;
